// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"FieldSwitchesGroup_toggleSwitch__gW61L","slider":"FieldSwitchesGroup_slider__aRfYf","labelText":"FieldSwitchesGroup_labelText__cLnBf"};